<template>
	<ui-dropdown
		:dropdown-class="
			(alignment == 'right' ? 'right-0' : 'left-0') +
			' ' +
			(verticalAlignment == 'bottom' ? 'bottom-12' : 'top-12') +
			' origin-top-right absolute mt-0 w-48 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none z-50 overflow-hidden'
		"
		:buttonClass="
			markInvalid
				? 'border-red-500 mt-1 px-3 py-2 rounded-md shadow-sm whitespace-nowrap text-gray-400 flex items-center w-full border focus:ring-1 focus:ring-orange-500 focus:border-orange-500 focus:text-orange-500 bg-white'
				: 'border-gray-300 mt-1 px-3 py-2 rounded-md shadow-sm whitespace-nowrap text-gray-400 flex items-center w-full border focus:ring-1 focus:ring-orange-500 focus:border-orange-500 focus:text-orange-500 bg-white'
		"
	>
		<template v-slot:button>
			<ui-icon
				v-if="icon"
				class="h-5 w-5 mr-3"
				:class="[markInvalid ? 'text-red-500' : 'text-gray-400']"
				name="calendar"
				stroke-width="2"
			/>
			<span
				:class="[
					val && !markInvalid ? 'text-gray-700' : '',
					val && markInvalid ? 'text-red-500' : 'text-gray-700',
				]"
				>{{ displayVal }}</span
			>
		</template>

		<!-- picker overlay -->
		<template v-slot:items>
			<div class="flex justify-between border-b border-gray-300" @click.stop="">
				<!-- previous year -->
				<button
					class="m-2 focus:ring-2 focus:ring-orange-500 focus:text-orange-500 rounded-sm cursor-pointer"
					:class="[
						!canSelect(picker.year - 1)
							? 'text-gray-300 cursor-not-allowed'
							: '',
					]"
					:disabled="!canSelect(picker.year - 1)"
					@click.prevent="picker.year--"
				>
					<ui-icon class="h-5 w-5" name="chevron-left" stroke-width="2" />
				</button>
				<!-- current year -->
				<p class="m-2 text-gray-700 font-medium">{{ picker.year }}</p>
				<!-- next year -->
				<button
					class="m-2 focus:ring-2 focus:ring-orange-500 focus:text-orange-500 rounded-sm cursor-pointer"
					:class="[
						!canSelect(picker.year + 1)
							? 'text-gray-300 cursor-not-allowed'
							: '',
					]"
					:disabled="!canSelect(picker.year + 1)"
					@click.prevent="picker.year++"
				>
					<ui-icon class="h-5 w-5" name="chevron-right" stroke-width="2" />
				</button>
			</div>
			<div class="grid grid-cols-4 grid-rows-3">
				<button
					v-for="(month, idx) in monthLabels"
					:key="idx"
					:class="[
						'px-3 py-2 focus:bg-orange-500 focus:text-white',
						isSelected(picker.year, idx + 1)
							? markInvalid
								? 'bg-red-500 text-white'
								: 'bg-orange-500 text-white'
							: canSelect(picker.year, idx + 1)
							? 'hover:bg-gray-100'
							: 'text-gray-300 cursor-not-allowed',
					]"
					:disabled="!canSelect(picker.year, idx + 1)"
					@click.prevent="
						canSelect(picker.year, idx + 1) ? (picker.month = idx + 1) : null
					"
				>
					{{ month }}
				</button>
			</div>
		</template>
	</ui-dropdown>
</template>

<script>
export default {
	props: {
		value: {
			required: false,
			type: String,
		},
		autocomplete: {
			type: String,
			default: "on",
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		markInvalid: {
			type: Boolean,
			default: false,
		},
		inputId: {
			type: String,
		},
		minDate: {
			type: String,
			default: "0000-00-01",
		},
		maxDate: {
			type: String,
			default: "9999-00-01",
		},
		icon: {
			type: Boolean,
			default: true,
		},
		alignment: {
			type: String,
			default: "left",
		},
		verticalAlignment: {
			/* not required here ?*/ type: String,
			default: "top",
		},
	},
	data() {
		return {
			val: this.value,
			picker: Vue.observable({
				year: this.value
					? this.value.substr(0, 4) * 1
					: new Date().getFullYear(),
				month: this.value ? this.value.substr(5, 2) * 1 : null,
			}),
		};
	},
	watch: {
		picker: {
			deep: true,
			handler(picker) {
				this.val = this.monthToIsoDate(picker.year, picker.month);
				this.$emit("input", this.val);
				this.$emit("change");
			},
		},
	},
	methods: {
		monthToIsoDate(year, month) {
			let v = [year, "-", month < 10 ? "0" : "", month, "-01"].join("");
			return v;
		},
		canSelect(year, month) {
			if (month) {
				let d = this.monthToIsoDate(year, month);
				return d >= this.minDate && d <= this.maxDate;
			} else {
				return true; // || year >= this.minDate.substr(0, 4) || year <= this.maxDate.substr(0, 4)
			}
		},
		isSelected(year, month) {
			return this.picker.year == year && this.picker.month == month;
		},
	},
	computed: {
		monthLabels() {
			return this.$cropOptions.monthLabels; // todo locale
		},
		displayVal() {
			if (this.val) {
				return [
					this.monthLabels[this.picker.month - 1],
					" ",
					this.picker.year,
				].join("");
			} else {
				return this.__("Please select");
			}
		},
	},
};
</script>
